var CRITERION_KEY_MAP, SUPPORTED_PRIMARY_SECTIONS, applyRecommendationUpdatesToEtdDoc, consensusFieldName, get, getRecommendationConclusionsSectionId, hasConclusionSection, hasJustificationSection, htmlToEscapedPlainText, isAiRecommendationGenerationSupported, isGpsEtdDoc, justificationPath, mapJustificationCriteria, mapRecommendationResponseToEtdUpdates, recommendationDataPath, resolveCriterionId, sanitizeCriterionJustificationText, set, _ref, _ref1,
  __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; },
  __slice = [].slice;

htmlToEscapedPlainText = require('base/lib/utils').htmlToEscapedPlainText;

_ref = require('lib/recommendation_section_helper'), getRecommendationConclusionsSectionId = _ref.getRecommendationConclusionsSectionId, hasConclusionSection = _ref.hasConclusionSection;

_ref1 = require('lodash'), get = _ref1.get, set = _ref1.set;

SUPPORTED_PRIMARY_SECTIONS = ['recommendation', 'decision', 'goodPracticeStatement'];

CRITERION_KEY_MAP = {
  problem: ['problem'],
  desirable_effects: ['desirableEffects'],
  undesirable_effects: ['undesirableEffects'],
  certainty_of_evidence: ['certaintyOfEvidence'],
  values: ['values', 'publicAndPatientsValuesAndPreferences', 'preferences'],
  balance_of_effects: ['balanceOfEffects'],
  resources_required: ['resourcesRequired', 'resourcesUtilization', 'resources'],
  certainty_of_evidence_of_required_resources: ['certaintyOfEvidenceOfRequiredResources'],
  cost_effectiveness: ['costEffectiveness'],
  equity: ['equity'],
  acceptability: ['acceptability'],
  feasibility: ['feasibility'],
  planetary_health_impact: ['planetaryBoundaries']
};

consensusFieldName = function(fieldName, isConsensus) {
  if (isConsensus) {
    return "" + fieldName + "Consensus";
  } else {
    return fieldName;
  }
};

isGpsEtdDoc = function(etdDoc) {
  var templateId;
  templateId = get(etdDoc, 'templateDef.id', '');
  return Boolean(get(etdDoc, 'gps')) || _.string.startsWith(templateId, 'good-practice-statement');
};

isAiRecommendationGenerationSupported = function(etdDoc) {
  return SUPPORTED_PRIMARY_SECTIONS.some(function(sectionId) {
    return hasConclusionSection(etdDoc, sectionId);
  });
};

hasJustificationSection = function(etdDoc) {
  return hasConclusionSection(etdDoc, 'justification');
};

resolveCriterionId = function(aiKey, sectionsOrder) {
  var candidates, _ref2;
  candidates = (_ref2 = CRITERION_KEY_MAP[aiKey]) != null ? _ref2 : [];
  return _.find(candidates, function(criterionId) {
    return __indexOf.call(sectionsOrder, criterionId) >= 0;
  });
};

recommendationDataPath = function(sectionId, field) {
  if (field == null) {
    field = 'content';
  }
  return ['templateData', 'conclusions', 'sections', sectionId, field];
};

justificationPath = function() {
  var subPath;
  subPath = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
  return ['templateData', 'conclusions', 'sections', 'justification'].concat(subPath);
};

sanitizeCriterionJustificationText = function(text) {
  return _.escape(String(text != null ? text : ''));
};

mapJustificationCriteria = function(justificationResponse, sectionsOrder) {
  var aiKey, criteria, criterionId, responseKey, text;
  if (justificationResponse == null) {
    return {};
  }
  criteria = {};
  for (aiKey in CRITERION_KEY_MAP) {
    responseKey = "" + aiKey + "_justification";
    text = justificationResponse[responseKey];
    if (text == null) {
      continue;
    }
    criterionId = resolveCriterionId(aiKey, sectionsOrder);
    if (criterionId == null) {
      continue;
    }
    criteria[criterionId] = sanitizeCriterionJustificationText(text);
  }
  return criteria;
};

mapRecommendationResponseToEtdUpdates = function(response, etdDoc, options) {
  var criteriaUpdates, isConsensus, isGps, justificationResponse, overallText, recommendationData, recommendationSectionId, sectionsOrder, updates, _ref2, _ref3, _ref4;
  if (options == null) {
    options = {};
  }
  isConsensus = (_ref2 = options.isConsensus) != null ? _ref2 : false;
  recommendationData = response != null ? response.recommendation : void 0;
  if ((recommendationData != null ? recommendationData.recommendation : void 0) == null) {
    throw new Error('AI recommendation result is missing');
  }
  isGps = isGpsEtdDoc(etdDoc);
  recommendationSectionId = getRecommendationConclusionsSectionId(etdDoc, isGps);
  sectionsOrder = (_ref3 = get(etdDoc, 'templateData.assessment.sectionsOrder')) != null ? _ref3 : [];
  updates = {
    isConsensus: isConsensus,
    recommendationSectionId: recommendationSectionId,
    recommendationContentField: consensusFieldName('content', isConsensus),
    recommendationContent: htmlToEscapedPlainText(recommendationData.recommendation)
  };
  if (hasJustificationSection(etdDoc)) {
    justificationResponse = (_ref4 = recommendationData.justification) != null ? _ref4 : {};
    overallText = justificationResponse.overall_justification;
    criteriaUpdates = mapJustificationCriteria(justificationResponse, sectionsOrder);
    if (overallText != null) {
      updates.justificationContentField = consensusFieldName('content', isConsensus);
      updates.justificationContent = htmlToEscapedPlainText(overallText);
    }
    if (!_.isEmpty(criteriaUpdates)) {
      updates.criteriaField = consensusFieldName('criteria', isConsensus);
      updates.criteriaUpdates = criteriaUpdates;
    }
  }
  return updates;
};

applyRecommendationUpdatesToEtdDoc = function(etdDoc, updates) {
  var criteriaField, criteriaPath, criteriaUpdates, existingCriteria, justificationContent, justificationContentField, recommendationContent, recommendationContentField, recommendationSectionId, _ref2;
  criteriaField = updates.criteriaField, criteriaUpdates = updates.criteriaUpdates, justificationContent = updates.justificationContent, justificationContentField = updates.justificationContentField, recommendationContent = updates.recommendationContent, recommendationContentField = updates.recommendationContentField, recommendationSectionId = updates.recommendationSectionId;
  set(etdDoc, recommendationDataPath(recommendationSectionId, recommendationContentField), recommendationContent);
  if (justificationContent != null) {
    set(etdDoc, justificationPath(justificationContentField), justificationContent);
  }
  if (criteriaUpdates != null) {
    criteriaPath = justificationPath('details', criteriaField);
    existingCriteria = (_ref2 = get(etdDoc, criteriaPath)) != null ? _ref2 : {};
    set(etdDoc, criteriaPath, _.extend({}, existingCriteria, criteriaUpdates));
  }
  return etdDoc;
};

module.exports = {
  applyRecommendationUpdatesToEtdDoc: applyRecommendationUpdatesToEtdDoc,
  consensusFieldName: consensusFieldName,
  hasJustificationSection: hasJustificationSection,
  isAiRecommendationGenerationSupported: isAiRecommendationGenerationSupported,
  mapRecommendationResponseToEtdUpdates: mapRecommendationResponseToEtdUpdates,
  resolveCriterionId: resolveCriterionId,
  sanitizeCriterionJustificationText: sanitizeCriterionJustificationText,
  SUPPORTED_PRIMARY_SECTIONS: SUPPORTED_PRIMARY_SECTIONS
};
